// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"231a0de1","321":"d008e5b1","395":"d1443f4e"}[chunkId] + ".chunk.js";
};